import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainMenuComponent } from './main-menu.component';
import { MenuItemsComponent } from './components/menu-items/menu-items.component';
import { SubmenuItemsComponent } from './components/submenu-items/submenu-items.component';
import { TooltipModule } from 'primeng/tooltip';
import { MenuLinkComponent } from './components/menu-link/menu-link.component';
import { RouterModule } from '@angular/router';
import { MAIN_MENU_FACADE_TOKEN } from './tokens/main-menu-facade.token';
import { mainMenuFacadeFactory } from './main-menu-facade.factory';
import { ConfigurationService } from '../../services/configuration.service';
import { MainMenuService } from './api/main-menu.service';
import { CookieService } from 'ngx-cookie-service';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [MainMenuComponent, SubmenuItemsComponent, MenuItemsComponent, MenuLinkComponent],
  imports: [CommonModule, TooltipModule, RouterModule, SharedModule],
  providers: [
    {
      provide: MAIN_MENU_FACADE_TOKEN,
      useFactory: mainMenuFacadeFactory,
      deps: [ConfigurationService, MainMenuService, CookieService],
    },
  ],
  exports: [MainMenuComponent],
})
export class MainMenuModule {}
